/**
 * Share preview URL builder.
 *
 * Returns the b2b-api link-preview endpoint URL for a given car offer id.
 * That endpoint (issue #909, MR !808) serves OG / Twitter Card metadata
 * to messenger crawlers (WhatsApp, Telegram, iMessage, Viber) and 302
 * redirects real users back into the SPA catalog. Sharing this URL from
 * the widget gives the user a link that renders a rich preview in chats,
 * unlike the bare host-page hash URL where `#/cars/{id}` never reaches
 * the server.
 *
 * Note on apiUrl normalisation: the widget mount config's `apiUrl` may or
 * may not include a trailing `/api` segment depending on how the host
 * embed sets it (see CLAUDE.md → "Double /api in Service API URL").
 * We strip it before re-appending the share path.
 */

import { config } from '../config/runtimeConfig';

const SHARE_ENDPOINT_PATH = '/api/public/share/cars';

/**
 * @param {string|number|null|undefined} carOfferId
 * @param {{apiUrl?: string}} [overrides] — used in unit tests
 * @returns {string|null} preview URL, or null if id/origin missing
 */
export function buildSharePreviewUrl(carOfferId, overrides = {}) {
  if (carOfferId === undefined || carOfferId === null || carOfferId === '') {
    return null;
  }
  const rawApiUrl = overrides.apiUrl ?? config.CAR_API_URL ?? '';
  // Strip optional trailing /api or /api/ to derive a clean origin.
  const origin = rawApiUrl.replace(/\/api\/?$/, '');
  if (!origin) return null;
  return `${origin}${SHARE_ENDPOINT_PATH}/${encodeURIComponent(String(carOfferId))}`;
}
